<template>
  <el-dialog
    class="modal-select-role"
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
    lock-scroll
    append-to-body
  >
    <div class="content" v-loading="isLoading">
      <div class="content-left">
        <div class="content-header">
          <el-input v-model="orgName" placeholder="组织名称" class="org-name__input"></el-input>
          <el-button @click="$_searchOrg" class="search__btn">查询</el-button>
          <el-button @click="$_resetFilter" class="reset__btn">重置</el-button>
        </div>
        <div class="content-main">
          <div class="content-main__label">组织名称</div>
          <div class="tree-wrap">
            <el-tree
              ref="org-tree"
              class="org-tree"
              :data="orgTreeData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @check="$_getCheckNode"
              show-checkbox
              :default-expanded-keys="expandedIds"
              :default-checked-keys="defaultCheckedKeys"
              node-key="orgId"
            ></el-tree>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="content-header">
          <div class="content-header__label">已选组织</div>
          <el-button @click="$_resetChecked" class="clear-btn">清空全部组织</el-button>
        </div>
        <div class="content-main">
          <div class="tree-wrap">
            <el-tree
              ref="org-tree-selected"
              class="org-tree__selected"
              :data="orgSelectedList"
              :props="defaultProps"
              default-expand-all
              node-key="orgId"
            ></el-tree>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <div class="edit__btns">
        <el-button class="save__btn" @click="$_submit">保存</el-button>
        <el-button class="cancel__btn" @click="$_cancle">{{cancleTxt}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as Utils from "@/plugins/utils";
export default {
  name: "modal-select-orgs",
  props: {
    title: { type: String, default: "" },
    cancleTxt: { type: String, default: "取消" },
    orgDataList: { type: Array, default: [] }, // 提供选择的组织数据, 由父组件传递
    orgSelecteds: { type: Array, default: [] } // 已选择的组织数据
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      orgName: "",
      defaultProps: {
        children: "children",
        label: "orgName"
      },
      defaultCheckedKeys: [],
      selectedList: []
    };
  },
  computed: {
    orgTreeData() {
      if (this.orgDataList.length > 0) {
        return Utils.catalogsToTree(this.orgDataList, "orgId", false);
      } else {
        return [];
      }
    },
    // 根据已选数据右侧进行预览
    orgSelectedList() {
      return Utils.catalogsToTree(this.selectedList, "orgId", false);
    },
    expandedIds(){
      return this.orgDataList.filter(item => item.level <=2).map(item => item.id);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    // 查询组织
    $_searchOrg() {
      if (this.orgTreeData.length > 0) {
        let orgName = this.orgName;
        this.$refs["org-tree"].filter(orgName);
      }
    },
    // 重置查询
    $_resetFilter() {
      this.orgName = "";
      this.$_searchOrg();
    },
    // 勾选左侧组织树节点时触发
    $_getCheckNode() {
      // this.$nextTick(() => {
      let checks = this.$refs["org-tree"].getCheckedNodes(false, true);
      this.selectedList = checks.map(ele => {
        let { orgId, parentId, orgName } = ele;
        return {
          orgId,
          parentId,
          orgName
        };
      });
      // });
    },
    // 清空全部组织
    $_resetChecked() {
      this.$refs["org-tree"].setCheckedKeys([]);
      this.selectedList.splice(0);
    },
    // 确认
    $_submit() {
      if (this.selectedList.length === 0) {
        $MessageBox.alert({ content: "请至少选择一个组织" });
        return false;
      }
      let checks = this.$refs["org-tree"].getCheckedNodes().map(item => {
        let { orgId, orgName } = item;
        return { orgId, orgName };
      });
      this.$emit("callback", checks.splice(0));
      this.$_cancle();
    },
    // 关闭本弹窗
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    }
  },
  mounted() {
    this.visible = true;
    if (this.orgSelecteds.length > 0) {
      this.defaultCheckedKeys = this.orgSelecteds.reduce(
        (prev, curr) => prev.concat([curr.orgId]),
        []
      );
      this.$nextTick(() => {
        this.$_getCheckNode();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
  padding: 20px 30px 16px;
  overflow: hidden;
  color: #535353;
  &-left,
  &-right {
    width: 459px;
    height: 549px;
    background-color: rgba(249, 249, 249, 1);
    border: 1px solid rgba(238, 238, 238, 1);
  }
  &-left {
    float: left;
    .content-header {
      display: flex;
      align-items: center;
      padding: 0 10px;
    }
    .org-name__input {
      width: 110px;
      margin-right: 10px;
    }
    .tree-wrap {
      height: 460px;
    }
  }
  &-right {
    float: right;
    .tree-wrap {
      height: 500px;
      padding: 10px 20px;
    }
  }
  &-header {
    position: relative;
    height: 40px;
    background-color: rgba(245, 246, 247, 1);
    border-bottom: 1px solid rgba(238, 238, 238, 1);
    &__label {
      position: absolute;
      left: 26px;
      top: 14px;
    }
  }
  &-main {
    height: calc(100% - 40px);
    overflow: hidden;
    &__label {
      padding-left: 12px;
      line-height: 40px;
      color: #3a3a3a;
      font-size: 14px;
      font-weight: bold;
    }
  }
}
.tree-wrap {
  overflow-y: auto;
}
.org-tree {
  /deep/ .el-tree-node {
    > .el-tree-node__children {
      overflow: unset;
    }
  }
}
.clear-btn {
  position: absolute;
  top: 7px;
  right: 12px;
  width: 100px;
  background-color: #f86d38;
  color: #fff;
  &:hover {
    background-color: #f77a4b;
  }
  &:focus {
    background-color: #ed5f29;
  }
}
</style>